import { Flex } from "@chakra-ui/layout";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { AiOutlineBank, AiOutlineGold } from "react-icons/ai";
import { MdArrowDropDown } from "react-icons/md";
import { FaExchangeAlt } from "react-icons/fa";
import { PessoaTipo } from "core/features/pessoas/typings";

function TabPessoasTableHeader({
  totalPages,
  onCreate,
  onChangeProprietario,
}: {
  totalPages: number;
  onCreate: (pessoaTipo: PessoaTipo) => void;
  onChangeProprietario: () => void;
}) {
  return (
    <Flex gap="16px">
      <Menu placement="right">
        <MenuButton
          as={Button}
          _hover={{ opacity: 0.8 }}
          _active={{ opacity: 0.8 }}
          color="#ffff"
          backgroundColor="#005081"
          rightIcon={<MdArrowDropDown />}
        >
          Adicionar
        </MenuButton>
        <MenuList>
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              onCreate(PessoaTipo.Fisica);
            }}
            icon={<AiOutlineBank fontSize={18} />}
          >
            Pessoa Física
          </MenuItem>
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              onCreate(PessoaTipo.Juridica);
            }}
            icon={<AiOutlineGold fontSize={18} />}
          >
            Pessoa Jurídica
          </MenuItem>
        </MenuList>
      </Menu>

      <Button
        isDisabled={!totalPages}
        onClick={onChangeProprietario}
        py="2px"
        gap="8px"
      >
        <FaExchangeAlt />
        Trocar proprietário
      </Button>
    </Flex>
  );
}

export default TabPessoasTableHeader;
